import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: 'input[type="text"]',
})
export class TextInputMaxLengthDirective implements AfterViewInit {
    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2
    ) { }

    public ngAfterViewInit(): void {
        const maxLengthValue = this._elementRef.nativeElement.getAttribute('maxLength');
        if (!maxLengthValue) {
            this._renderer.setAttribute(this._elementRef.nativeElement, 'maxLength', '191');
        }
    }
}

